import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router'
import './styles.css'

import { LoginScreen } from './routes/login.tsx'
import { SiteLayout } from './routes/site-layout.tsx'
import { ArticleGrid } from './routes/article-grid.tsx'
import { ArticleEditor } from './routes/article-editor.tsx'
import { RequireAuth } from './routes/require-auth.tsx'
import { Cockpit } from './routes/cockpit.tsx'
import { UniversalScreen } from './routes/universal-screen.tsx'
import { CorpusScreen } from './routes/corpus-screen.tsx'
import { KeywordsScreen } from './routes/keywords-screen.tsx'
import { StandardsScreen } from './routes/standards-screen.tsx'
import { AnalyticsScreen } from './routes/analytics-screen.tsx'
import { TrainScreen } from './routes/train-screen.tsx'

const router = createBrowserRouter([
  { path: '/login', element: <LoginScreen /> },
  {
    element: <RequireAuth />,
    children: [
      { path: '/', element: <Navigate to="/sites/chc" replace /> },
      {
        path: '/sites/:siteId',
        element: <SiteLayout />,
        children: [
          { index: true, element: <Cockpit /> },
          { path: 'articles', element: <ArticleGrid /> },
          { path: 'articles/:slug', element: <ArticleEditor /> },
          { path: 'universal', element: <UniversalScreen /> },
          { path: 'corpus', element: <CorpusScreen /> },
          { path: 'keywords', element: <KeywordsScreen /> },
          { path: 'train', element: <TrainScreen /> },
          { path: 'standards', element: <StandardsScreen /> },
          { path: 'analytics', element: <AnalyticsScreen /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
